import theme from 'ThemeProvider/theme';
import sx from 'utils/createSx';

export default sx({
  container: {
    minHeight: '100vh',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
    backgroundColor: theme.palette.grey[50],
  },

  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.common.white,
  },

  title: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },

  subtitle: {
    opacity: 0.9,
  },

  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
    fontSize: '1rem',
  },

  card: {
    marginBottom: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
    backgroundColor: theme.palette.common.white,
  },

  divider: {
    marginY: theme.spacing(3),
  },

  // Estilos para endereço selecionado
  addressText: {
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },

  addressDetails: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.25),
  },

  // Estilos para opções de frete
  shippingCard: {
    marginBottom: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[200]}`,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
    },
  },

  shippingCardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },

  radio: {
    color: theme.palette.primary.main,
  },

  shippingTitle: {
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },

  shippingDetails: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },

  shippingPrice: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },

  disclaimer: {
    display: 'block',
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },

  shippingInfo: {
    marginTop: theme.spacing(2),
  },

  // Estilos para resumo do pedido
  summaryCard: {
    position: 'sticky',
    top: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    backgroundColor: theme.palette.common.white,
  },

  cartItems: {
    marginBottom: theme.spacing(2),
  },

  cartItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingY: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },

  itemInfo: {
    flex: 1,
    marginRight: theme.spacing(2),
  },

  itemName: {
    fontWeight: 500,
    marginBottom: theme.spacing(0.25),
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },

  itemDetails: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },

  itemPrice: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    minWidth: 'fit-content',
  },

  summaryDivider: {
    marginY: theme.spacing(2),
  },

  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },

  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: `2px solid ${theme.palette.primary.main}`,
  },

  totalLabel: {
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },

  totalValue: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },

  // Seção de assinante
  subscriberSection: {
    backgroundColor: theme.palette.success.light,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },

  subscriberLabel: {
    color: theme.palette.success.dark,
    fontWeight: 600,
    fontSize: '0.875rem',
  },

  checkoutButton: {
    marginTop: theme.spacing(3),
    paddingY: theme.spacing(1.5),
    fontWeight: 600,
    fontSize: '1rem',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[600],
    },
  },
});
